<template>
  <div class="containerInfo">
    <el-row type="flex" justify="space-around">
      <el-col :lg="14" :sm="24" :xs="24">
        <el-card class="box-card">
          <div
            slot="header"
            class="clearfix"
            style="font-weight: bold; display: flex; align-items: center"
          >
            <img
              src="@/assets/recruit/juxing.png"
              alt="Logo"
              style="margin-right: 12px"
            /><span><b>工作经历</b> </span>
            <!--            <span v-if="isProfessionTech || isTechnique" style="float: right"-->
            <!--              >(*为必填项，投递时上传附件中包含的信息可以不填，有留学经历的在国(境)外留学情况选择:是)</span-->
            <!--            >-->
          </div>
          <el-form ref="postForm" :model="form">
            <div>
              <div style="margin-bottom: 10px">
                <el-row>
                  <el-col :lg="8" :sm="24" :xs="24">
                    <el-form-item
                      label="是否有实习经历:"
                      prop="hasFamily"
                      :required="true"
                    >
                      <zr-combobox
                        v-model="form.hasPractice"
                        placeholder="是否有实习经历"
                        :data-array="[
                          { name: '是', code: '是' },
                          { name: '否', code: '否' },
                        ]"
                        value-field="code"
                        label-field="name"
                        style="width: 135px"
                        @change="hasPracticeChange"
                      ></zr-combobox>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row v-if="showPracticeAddButton">
                  <el-col :span="20"
                    ><span class="spanTitle" style="margin-left: 10px"
                      >实习经历:
                      <el-button
                        style="border: 1px solid #1890ff; margin-left: 60px"
                        @click="addPracticeLive"
                        ><i class="el-icon-plus" style="color: #1890ff"
                          ><a style="color: #1890ff">添加实习经历</a></i
                        ></el-button
                      ></span
                    >
                  </el-col>
                </el-row>
              </div>
              <el-card
                v-for="row in form.parcticeLiveList"
                :key="row.id"
                style="background-color: #f5f7fa"
              >
                <div slot="header">
                  <el-button
                    style="float: right; padding: 3px 0"
                    icon="el-icon-minus"
                    type="text"
                    @click="delPracticeLive(row)"
                    >删除</el-button
                  >
                </div>
                <el-row>
                  <el-col :lg="8" :sm="24" :xs="24">
                    <el-form-item
                      label="开始日期:"
                      label-width="100px"
                      :required="true"
                    >
                      <el-date-picker
                        v-model="row.startLiveTime"
                        align="right"
                        type="date"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        placeholder="选择开始日期"
                        style="width: 135px"
                      ></el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :lg="8" :sm="24" :xs="24">
                    <el-form-item
                      label="结束日期:"
                      label-width="100px"
                      :required="true"
                    >
                      <el-date-picker
                        v-model="row.endLiveTime"
                        align="right"
                        type="date"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        placeholder="选择结束日期"
                        style="width: 135px"
                      ></el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :lg="8" :sm="24" :xs="24">
                    <el-form-item
                      label="单位名称:"
                      label-width="100px"
                      :required="true"
                    >
                      <el-col :span="16">
                        <el-input
                          v-model="row.companyName"
                          placeholder="请输入单位名称"
                          maxlength="32"
                        ></el-input>
                      </el-col>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :lg="8" :sm="24" :xs="24">
                    <el-form-item
                      label="地点:"
                      label-width="100px"
                      :required="true"
                    >
                      <el-col :span="16"
                        ><el-input
                          v-model="row.location"
                          placeholder="请输入地点"
                          maxlength="32"
                        />
                      </el-col>
                    </el-form-item>
                  </el-col>
                  <el-col :lg="8" :sm="24" :xs="24">
                    <el-form-item
                      label="任职部门:"
                      label-width="100px"
                      :required="true"
                    >
                      <el-col :span="16">
                        <el-input
                          v-model="row.workDeptName"
                          placeholder="请输入任职部门"
                          size="mini"
                          maxlength="30"
                        ></el-input>
                      </el-col>
                    </el-form-item>
                  </el-col>
                  <el-col :lg="8" :sm="24" :xs="24">
                    <el-form-item
                      label="任职职位:"
                      label-width="100px"
                      :required="true"
                    >
                      <el-col :span="16">
                        <el-input
                          v-model="row.workPostName"
                          placeholder="请输入任职职位"
                          maxlength="30"
                        />
                      </el-col>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :lg="24" :sm="24" :xs="24">
                    <el-form-item
                      label="主要职责与业绩:"
                      label-width="100px"
                      :required="true"
                    >
                      <el-col :span="17">
                        <el-input
                          v-model="row.achievement"
                          placeholder="请输入主要职责与业绩"
                          maxlength="200"
                        />
                      </el-col>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-card>
              <div style="margin-bottom: 10px">
                <el-row>
                  <el-col :lg="8" :sm="24" :xs="24">
                    <el-form-item
                      label="是否有工作经历:"
                      prop="hasWorkLive"
                      :required="true"
                    >
                      <zr-combobox
                        v-model="form.hasWorkLive"
                        placeholder="是否有工作经历"
                        :data-array="[
                          { name: '是', code: '是' },
                          { name: '否', code: '否' },
                        ]"
                        value-field="code"
                        label-field="name"
                        style="width: 135px"
                        @change="hasWorkLiveChange"
                      ></zr-combobox>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row v-if="showWorkLiveAddButton">
                  <el-col :span="20" style="margin-left: 10px"
                    ><span class="spanTitle"
                      >工作经历:
                      <el-button
                        style="border: 1px solid #1890ff; margin-left: 60px"
                        @click="addWorkLive"
                        ><i class="el-icon-plus" style="color: #1890ff"
                          ><a style="color: #1890ff">添加工作经历</a></i
                        ></el-button
                      ></span
                    >
                  </el-col>
                </el-row>
              </div>
              <el-card
                v-for="row in form.workLiveList"
                :key="row.id"
                style="background-color: #f5f7fa"
              >
                <div slot="header">
                  <el-button
                    style="float: right; padding: 3px 0"
                    icon="el-icon-minus"
                    type="text"
                    @click="delWorkLive(row)"
                    >删除</el-button
                  >
                </div>
                <el-row>
                  <el-col :lg="8" :sm="24" :xs="24">
                    <el-form-item
                      label="开始日期:"
                      label-width="100px"
                      :required="true"
                    >
                      <el-date-picker
                        v-model="row.startLiveTime"
                        align="right"
                        type="date"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        placeholder="选择开始日期"
                        style="width: 135px"
                      ></el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :lg="8" :sm="24" :xs="24">
                    <el-form-item
                      label="结束日期:"
                      label-width="100px"
                      :required="true"
                    >
                      <el-date-picker
                        v-model="row.endLiveTime"
                        align="right"
                        type="date"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        placeholder="选择结束日期"
                        style="width: 135px"
                      ></el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :lg="8" :sm="24" :xs="24">
                    <el-form-item
                      label="单位名称:"
                      label-width="100px"
                      :required="true"
                    >
                      <el-col :span="16">
                        <el-input
                          v-model="row.companyName"
                          placeholder="请输入单位名称"
                          size="mini"
                          maxlength="32"
                        ></el-input>
                      </el-col>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :lg="8" :sm="24" :xs="24">
                    <el-form-item
                      label="地点:"
                      label-width="100px"
                      :required="true"
                    >
                      <el-col :span="16">
                        <el-input
                          v-model="row.location"
                          placeholder="请输入地点"
                          maxlength="15"
                        />
                      </el-col>
                    </el-form-item>
                  </el-col>
                  <el-col :lg="8" :sm="24" :xs="24">
                    <el-form-item
                      label="任职部门:"
                      label-width="100px"
                      :required="true"
                    >
                      <el-col :span="16">
                        <el-input
                          v-model="row.workDeptName"
                          placeholder="请输入任职部门"
                          maxlength="30"
                        ></el-input>
                      </el-col>
                    </el-form-item>
                  </el-col>
                  <el-col :lg="8" :sm="24" :xs="24">
                    <el-form-item
                      label="任职职位:"
                      label-width="100px"
                      :required="true"
                    >
                      <el-col :span="16">
                        <el-input
                          v-model="row.workPostName"
                          placeholder="请输入任职职位"
                          maxlength="30"
                        />
                      </el-col>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :lg="24" :sm="24" :xs="24">
                    <el-form-item
                      label="主要职责与业绩:"
                      label-width="100px"
                      :required="true"
                    >
                      <el-col :span="17">
                        <el-input
                          v-model="row.achievement"
                          placeholder="请输入主要职责与业绩"
                          maxlength="200"
                        />
                      </el-col>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-card>
              <div style="margin-bottom: 10px">
                <el-row>
                  <el-col :lg="8" :sm="24" :xs="24">
                    <el-form-item
                      label="是否有项目经历:"
                      prop="hasProjectLive"
                      :required="true"
                    >
                      <zr-combobox
                        v-model="form.hasProjectLive"
                        placeholder="是否有项目经历"
                        :data-array="[
                          { name: '是', code: '是' },
                          { name: '否', code: '否' },
                        ]"
                        value-field="code"
                        label-field="name"
                        style="width: 135px"
                        @change="hasProjectLiveChange"
                      ></zr-combobox>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row v-if="showProjectLiveAddButton">
                  <el-col :span="20" style="margin-left: 10px"
                    ><span class="spanTitle"
                      >项目经历:
                      <el-button
                        style="border: 1px solid #1890ff; margin-left: 60px"
                        @click="addProjectLive"
                        ><i class="el-icon-plus" style="color: #1890ff"
                          ><a style="color: #1890ff">科研项目经历</a></i
                        ></el-button
                      ></span
                    >
                  </el-col>
                </el-row>
              </div>
              <el-card
                v-for="row in form.projectLiveList"
                :key="row.id"
                style="background-color: #f5f7fa"
              >
                <div slot="header">
                  <el-button
                    style="float: right; padding: 3px 0"
                    icon="el-icon-minus"
                    type="text"
                    @click="delProjectLive(row)"
                    >删除</el-button
                  >
                </div>
                <el-row>
                  <el-col :lg="8" :sm="24" :xs="24">
                    <el-form-item
                      label="开始日期:"
                      label-width="100px"
                      :required="true"
                    >
                      <el-date-picker
                        v-model="row.startLiveTime"
                        align="right"
                        type="date"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        placeholder="选择开始日期"
                        style="width: 135px"
                      ></el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :lg="8" :sm="24" :xs="24">
                    <el-form-item
                      label="结束日期:"
                      label-width="100px"
                      :required="true"
                    >
                      <el-date-picker
                        v-model="row.endLiveTime"
                        align="right"
                        type="date"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        placeholder="选择结束日期"
                        style="width: 135px"
                      ></el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :lg="8" :sm="24" :xs="24">
                    <el-form-item
                      label="项目名称:"
                      label-width="100px"
                      :required="true"
                    >
                      <el-col :span="16">
                        <el-input
                          v-model="row['projectName']"
                          placeholder="请输入项目名称"
                          size="mini"
                          maxlength="30"
                        ></el-input>
                      </el-col>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :lg="8" :sm="24" :xs="24">
                    <el-form-item
                      label="项目角色:"
                      label-width="100px"
                      :required="true"
                    >
                      <el-col :span="16">
                        <el-input
                          v-model="row.projectRole"
                          placeholder="请输入项目角色"
                          maxlength="15"
                        />
                      </el-col>
                    </el-form-item>
                  </el-col>
                  <el-col :lg="8" :sm="24" :xs="24">
                    <el-form-item
                      label="单位名称:"
                      label-width="100px"
                      :required="true"
                    >
                      <el-col :span="16">
                        <el-input
                          v-model="row.companyName"
                          placeholder="请输入单位名称"
                          size="mini"
                          maxlength="30"
                        ></el-input>
                      </el-col>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :lg="24" :sm="24" :xs="24">
                    <el-form-item
                      label="主要职责与业绩:"
                      label-width="100px"
                      :required="true"
                    >
                      <el-col :span="17">
                        <el-input
                          v-model="row.achievement"
                          placeholder="请输入主要职责与业绩(限200字)"
                          maxlength="200"
                        />
                      </el-col>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-card>
            </div>
            <div style="text-align: center">
              <slot name="footBtn" :form="form">
                <el-button icon="el-icon-circle-check" @click="preActive"
                  >上一步</el-button
                >
                <el-button
                  icon="el-icon-circle-check"
                  type="primary"
                  @click="nextActice"
                  >下一步</el-button
                >
                <el-button icon="el-icon-back" plain @click="back"
                  >返回</el-button
                >
              </slot>
            </div>
          </el-form>
        </el-card>
      </el-col>
    </el-row>
    <!--  <el-row type="flex" justify="space-around">-->
    <!--    <el-col :lg="14" :sm="24" :xs="24">-->
    <!--      <el-card class="box-card">-->
    <!--        <div slot="header" class="clearfix" style="font-weight: bold">-->
    <!--          <span><b>工作经历</b> </span>-->
    <!--        </div>-->
    <!--        <el-form ref="postForm" :model="form">-->
    <!--          <div style="margin-bottom: 10px">-->
    <!--            <el-row>-->
    <!--              <el-col :span="20"-->
    <!--                ><span class="spanTitle">实习经历:-->
    <!--                   <el-button-->
    <!--                       style="border: 1px solid #1890FF;margin-left: 10px"-->
    <!--                       @click="addPracticeLive"-->
    <!--                   ><i class="el-icon-plus icon-color"><a style="color: #1890FF">添加实习经历</a></i></el-button-->
    <!--                   ></span>-->
    <!--              </el-col>-->
    <!--            </el-row>-->
    <!--          </div>-->
    <!--          <el-card>-->
    <!--            <div style="overflow: auto; height: 240px">-->
    <!--              <zr-table-->
    <!--                ref="familyTable"-->
    <!--                height-fixed-->
    <!--                class="user-box"-->
    <!--                selection-type="single"-->
    <!--                :data="form.parcticeLiveList"-->
    <!--                :columns="parcticeLiveColumns"-->
    <!--                table-height="200px"-->
    <!--                stripe-->
    <!--              >-->
    <!--                <template v-slot:startLiveTime="{ row }">-->
    <!--                  <el-date-picker-->
    <!--                    v-model="row['startLiveTime']"-->
    <!--                    type="date"-->
    <!--                    placeholder="选择开始日期"-->
    <!--                  >-->
    <!--                  </el-date-picker>-->
    <!--                </template>-->
    <!--                <template v-slot:endLiveTime="{ row }">-->
    <!--                  <el-date-picker-->
    <!--                    v-model="row['endLiveTime']"-->
    <!--                    type="date"-->
    <!--                    placeholder="选择结束日期"-->
    <!--                  >-->
    <!--                  </el-date-picker>-->
    <!--                </template>-->
    <!--                <template v-slot:companyName="{ row }">-->
    <!--                  <el-input-->
    <!--                    v-model="row['companyName']"-->
    <!--                    size="mini"-->
    <!--                    maxlength="32"-->
    <!--                  ></el-input>-->
    <!--                </template>-->
    <!--                <template v-slot:location="{ row }">-->
    <!--                  <el-input-->
    <!--                    v-model="row['location']"-->
    <!--                    size="mini"-->
    <!--                    maxlength="32"-->
    <!--                  ></el-input>-->
    <!--                </template>-->
    <!--                <template v-slot:workDeptName="{ row }">-->
    <!--                  <el-input-->
    <!--                    v-model="row['workDeptName']"-->
    <!--                    size="mini"-->
    <!--                    maxlength="500"-->
    <!--                  ></el-input>-->
    <!--                </template>-->
    <!--                <template v-slot:workPostName="{ row }">-->
    <!--                  <el-input-->
    <!--                    v-model="row['workPostName']"-->
    <!--                    size="mini"-->
    <!--                    maxlength="500"-->
    <!--                  ></el-input>-->
    <!--                </template>-->
    <!--                <template v-slot:achievement="{ row }">-->
    <!--                  <el-input-->
    <!--                    v-model="row['achievement']"-->
    <!--                    size="mini"-->
    <!--                    maxlength="500"-->
    <!--                    clearable-->
    <!--                  ></el-input>-->
    <!--                </template>-->
    <!--                <template v-slot:operate="{ row }">-->
    <!--                  <el-button type="text" @click="delPracticeLive(row)"-->
    <!--                    >删除</el-button-->
    <!--                  >-->
    <!--                </template>-->
    <!--              </zr-table>-->
    <!--            </div>-->
    <!--          </el-card>-->
    <!--          <div style="margin-bottom: 10px">-->
    <!--            <el-row>-->
    <!--              <el-col :span="20"-->
    <!--              ><span class="spanTitle">工作经历:-->
    <!--                   <el-button-->
    <!--                       style="border: 1px solid #1890FF;margin-left: 10px"-->
    <!--                       @click="addWorkLive"-->
    <!--                   ><i class="el-icon-plus icon-color"><a style="color: #1890FF">添加工作经历</a></i></el-button-->
    <!--                   ></span>-->
    <!--              </el-col>-->
    <!--            </el-row>-->
    <!--          </div>-->
    <!--          <el-card>-->
    <!--            <div style="overflow: auto; height: 240px">-->
    <!--              <zr-table-->
    <!--                ref="familyTable"-->
    <!--                height-fixed-->
    <!--                class="user-box"-->
    <!--                selection-type="single"-->
    <!--                :data="form.workLiveList"-->
    <!--                :columns="workLiveColumns"-->
    <!--                table-height="200px"-->
    <!--                stripe-->
    <!--              >-->
    <!--                <template v-slot:startLiveTime="{ row }">-->
    <!--                  <el-date-picker-->
    <!--                    v-model="row['startLiveTime']"-->
    <!--                    type="date"-->
    <!--                    placeholder="选择开始日期"-->
    <!--                  >-->
    <!--                  </el-date-picker>-->
    <!--                </template>-->
    <!--                <template v-slot:endLiveTime="{ row }">-->
    <!--                  <el-date-picker-->
    <!--                    v-model="row['endLiveTime']"-->
    <!--                    type="date"-->
    <!--                    placeholder="选择结束日期"-->
    <!--                  >-->
    <!--                  </el-date-picker>-->
    <!--                </template>-->
    <!--                <template v-slot:companyName="{ row }">-->
    <!--                  <el-input-->
    <!--                    v-model="row['companyName']"-->
    <!--                    size="mini"-->
    <!--                    maxlength="32"-->
    <!--                  ></el-input>-->
    <!--                </template>-->
    <!--                <template v-slot:location="{ row }">-->
    <!--                  <el-input-->
    <!--                    v-model="row['location']"-->
    <!--                    size="mini"-->
    <!--                    maxlength="32"-->
    <!--                  ></el-input>-->
    <!--                </template>-->
    <!--                <template v-slot:workDeptName="{ row }">-->
    <!--                  <el-input-->
    <!--                    v-model="row['workDeptName']"-->
    <!--                    size="mini"-->
    <!--                    maxlength="500"-->
    <!--                  ></el-input>-->
    <!--                </template>-->
    <!--                <template v-slot:workPostName="{ row }">-->
    <!--                  <el-input-->
    <!--                    v-model="row['workPostName']"-->
    <!--                    size="mini"-->
    <!--                    maxlength="500"-->
    <!--                  ></el-input>-->
    <!--                </template>-->
    <!--                <template v-slot:achievement="{ row }">-->
    <!--                  <el-input-->
    <!--                    v-model="row['achievement']"-->
    <!--                    size="mini"-->
    <!--                    maxlength="500"-->
    <!--                    clearable-->
    <!--                  ></el-input>-->
    <!--                </template>-->
    <!--                <template v-slot:operate="{ row }">-->
    <!--                  <el-button type="text" @click="delWorkLive(row)"-->
    <!--                    >删除</el-button-->
    <!--                  >-->
    <!--                </template>-->
    <!--              </zr-table>-->
    <!--            </div>-->
    <!--          </el-card>-->
    <!--          <div style="margin-bottom: 10px">-->
    <!--            <el-row>-->
    <!--              <el-col :span="20"-->
    <!--              ><span class="spanTitle">科研项目经历:-->
    <!--                   <el-button-->
    <!--                       style="border: 1px solid #1890FF;margin-left: 10px"-->
    <!--                       @click="addProjectLive"-->
    <!--                   ><i class="el-icon-plus icon-color"><a style="color: #1890FF">添加科研项目经历</a></i></el-button-->
    <!--                   ></span>-->
    <!--              </el-col>-->
    <!--            </el-row>-->
    <!--          </div>-->
    <!--          <el-card>-->
    <!--            <div style="overflow: auto; height: 240px">-->
    <!--              <zr-table-->
    <!--                ref="familyTable"-->
    <!--                height-fixed-->
    <!--                class="user-box"-->
    <!--                selection-type="single"-->
    <!--                :data="form.projectLiveList"-->
    <!--                :columns="projectLiveColumns"-->
    <!--                table-height="200px"-->
    <!--                stripe-->
    <!--              >-->
    <!--                <template v-slot:startLiveTime="{ row }">-->
    <!--                  <el-date-picker-->
    <!--                    v-model="row['startLiveTime']"-->
    <!--                    type="date"-->
    <!--                    placeholder="选择开始日期"-->
    <!--                  >-->
    <!--                  </el-date-picker>-->
    <!--                </template>-->
    <!--                <template v-slot:endLiveTime="{ row }">-->
    <!--                  <el-date-picker-->
    <!--                    v-model="row['endLiveTime']"-->
    <!--                    type="date"-->
    <!--                    placeholder="选择结束日期"-->
    <!--                  >-->
    <!--                  </el-date-picker>-->
    <!--                </template>-->
    <!--                <template v-slot:projectName="{ row }">-->
    <!--                  <el-input-->
    <!--                    v-model="row['projectName']"-->
    <!--                    size="mini"-->
    <!--                    maxlength="32"-->
    <!--                  ></el-input>-->
    <!--                </template>-->
    <!--                <template v-slot:projectRole="{ row }">-->
    <!--                  <el-input-->
    <!--                    v-model="row['projectRole']"-->
    <!--                    size="mini"-->
    <!--                    maxlength="32"-->
    <!--                  ></el-input>-->
    <!--                </template>-->
    <!--                <template v-slot:companyName="{ row }">-->
    <!--                  <el-input-->
    <!--                    v-model="row['companyName']"-->
    <!--                    size="mini"-->
    <!--                    maxlength="500"-->
    <!--                  ></el-input>-->
    <!--                </template>-->
    <!--                <template v-slot:achievement="{ row }">-->
    <!--                  <el-input-->
    <!--                    v-model="row['achievement']"-->
    <!--                    size="mini"-->
    <!--                    clearable-->
    <!--                    maxlength="500"-->
    <!--                  ></el-input>-->
    <!--                </template>-->
    <!--                <template v-slot:operate="{ row }">-->
    <!--                  <el-button type="text" @click="delProjectLive(row)"-->
    <!--                    >删除</el-button-->
    <!--                  >-->
    <!--                </template>-->
    <!--              </zr-table>-->
    <!--            </div>-->
    <!--          </el-card>-->
    <!--        </el-form>-->
    <!--        <div style="text-align: center">-->
    <!--          <slot name="footBtn" :form="form">-->
    <!--            <el-button icon="el-icon-circle-check" @click="preActive"-->
    <!--              >上一步</el-button-->
    <!--            >-->
    <!--&lt;!&ndash;            <el-button icon="el-icon-circle-check">保存</el-button>&ndash;&gt;-->
    <!--            <el-button-->
    <!--              icon="el-icon-circle-check"-->
    <!--              type="primary"-->
    <!--              @click="nextActice"-->
    <!--              >下一步</el-button-->
    <!--            >-->
    <!--            <el-button-->
    <!--                icon="el-icon-back"-->
    <!--                plain-->
    <!--                @click="back"-->
    <!--            >返回</el-button-->
    <!--            >-->
    <!--          </slot>-->
    <!--        </div>-->
    <!--      </el-card>-->
    <!--    </el-col>-->
    <!--  </el-row>-->
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import isMobile from "@/utils/device";
import settingHelp from "@/config/localSetting";
import store from "@/store";
const config = settingHelp.getConfig();
const { remoteURL } = config;
const token1 = localStorage.getItem("token");
const token2 = store.getters["user/accessToken"];
const token = token2 ? token2 : token1;
export default {
  name: "PersonalExperience",
  props: {
    form: {
      type: Object,
      default() {
        return {};
      },
    },
    isPost: {
      type: Boolean,
      default: false,
    },
    isRequired: {
      type: Boolean,
      default: true,
    },
    isView: {
      type: Boolean,
      default: false,
    },
    isTechnique: {
      type: Boolean,
      default: false,
    },
    isProfessionTech: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // isRequired: true, //学生编辑模式
      // isView: false, // 管理员查看模式
      // isTechnique: false, // 技能类
      // isProfessionTech: true, // 专技类
      parcticeLiveColumns: [
        { name: "开始时间", code: "startLiveTime", needDrawCell: true },
        { name: "结束时间", code: "endLiveTime", needDrawCell: true },
        { name: "单位名称", code: "companyName", needDrawCell: true },
        { name: "地点", code: "location", needDrawCell: true },
        { name: "任职部门", code: "workDeptName", needDrawCell: true },
        { name: "任职职位", code: "workPostName", needDrawCell: true },
        {
          name: "主要职责与业绩",
          code: "achievement",
          needDrawCell: true,
          width: "120",
        },
        { name: "操作", code: "operate", needDrawCell: true },
      ],
      workLiveColumns: [
        { name: "开始时间", code: "startLiveTime", needDrawCell: true },
        { name: "结束时间", code: "endLiveTime", needDrawCell: true },
        { name: "单位名称", code: "companyName", needDrawCell: true },
        { name: "地点", code: "location", needDrawCell: true },
        { name: "任职部门", code: "workDeptName", needDrawCell: true },
        { name: "任职职位", code: "workPostName", needDrawCell: true },
        {
          name: "主要职责与业绩",
          code: "achievement",
          needDrawCell: true,
          width: "120",
        },
        { name: "操作", code: "operate", needDrawCell: true },
      ],
      projectLiveColumns: [
        { name: "开始时间", code: "startLiveTime", needDrawCell: true },
        { name: "结束时间", code: "endLiveTime", needDrawCell: true },
        { name: "项目名称", code: "projectName", needDrawCell: true },
        { name: "角色", code: "projectRole", needDrawCell: true },
        { name: "单位名称", code: "companyName", needDrawCell: true },
        {
          name: "主要职责与业绩",
          code: "achievement",
          needDrawCell: true,
          width: "120",
        },
        { name: "操作", code: "operate", needDrawCell: true },
      ],
      showPracticeAddButton: true,
      showProjectLiveAddButton: true,
      showWorkLiveAddButton: true,
    };
  },
  computed: {
    ...mapGetters({
      userPhone: "user/userPhone",
      userName: "user/userName",
      userCode: "user/userCode",
    }),
  },
  async created() {
    // 判断是否是移动设备
    this.isMb = await isMobile();
    // 路由参数 判断页面状态
    if (this.$route.query.isView) {
      this.isView = true;
      this.isRequired = false;
    }
    if (this.form.postSendId) this.postSendId = this.form.postSendId;
    if (this.form.isProfessionTech)
      this.isProfessionTech = this.form.isProfessionTech;
    if (this.form.isTechnique) this.isTechnique = this.form.isTechnique;
    if (this.form.hasWorkLive === "是") {
      this.showWorkLiveAddButton = true;
    } else {
      this.showWorkLiveAddButton = false;
    }
    if (this.form.hasProjectLive === "是") {
      this.showProjectLiveAddButton = true;
    } else {
      this.showProjectLiveAddButton = false;
    }
    if (this.form.hasPractice === "是") {
      this.showPracticeAddButton = true;
    } else {
      this.showPracticeAddButton = false;
    }
  },
  methods: {
    childDataCheck() {
      let data = this.form;
      if (data.hasPractice === "是" && data.parcticeLiveList.length === 0) {
        this.$message.warning("实习经历不能为空！");
        return false;
      }
      if (data.hasWorkLive === "是" && data.workLiveList.length === 0) {
        this.$message.warning("工作经历不能为空！");
        return false;
      }
      if (data.hasProjectLive === "是" && data.projectLiveList.length === 0) {
        this.$message.warning("科研项目经历不能为空！");
        return false;
      }
      for (let i = 0; i < data.parcticeLiveList.length; i++) {
        let parcticeLive = data.parcticeLiveList[i];
        if (!parcticeLive.startLiveTime || parcticeLive.startLiveTime === "") {
          this.$message.warning("实习经历开始时间不能为空！");
          return false;
        }
        if (!parcticeLive.endLiveTime || parcticeLive.endLiveTime === "") {
          this.$message.warning("实习经历结束时间不能为空！");
          return false;
        }
        if (parcticeLive.endLiveTime < parcticeLive.startLiveTime) {
          this.$message.warning("实习经历结束时间不能小于开始时间！");
          return false;
        }
        if (!parcticeLive.companyName || parcticeLive.companyName === "") {
          this.$message.warning("实习经历单位名称不能为空！");
          return false;
        }
        if (!parcticeLive.location || parcticeLive.location === "") {
          this.$message.warning("实习经历地点不能为空！");
          return false;
        }
        if (!parcticeLive.workDeptName || parcticeLive.workDeptName === "") {
          this.$message.warning("实习经历任职部门不能为空！");
          return false;
        }
        if (!parcticeLive.workPostName || parcticeLive.workPostName === "") {
          this.$message.warning("实习经历任职职位不能为空！");
          return false;
        }
        if (!parcticeLive.achievement || parcticeLive.achievement === "") {
          this.$message.warning("实习经历业绩不能为空！");
          return false;
        }
      }
      for (let i = 0; i < data.workLiveList.length; i++) {
        let workLive = data.workLiveList[i];
        if (!workLive.startLiveTime || workLive.startLiveTime === "") {
          this.$message.warning("工作经历开始时间不能为空！");
          return false;
        }
        if (!workLive.endLiveTime || workLive.endLiveTime === "") {
          this.$message.warning("工作经历结束时间不能为空！");
          return false;
        }
        if (workLive.endLiveTime < workLive.startLiveTime) {
          this.$message.warning("工作经历结束时间不能小于开始时间！");
          return false;
        }
        if (!workLive.companyName || workLive.companyName === "") {
          this.$message.warning("工作经历单位名称不能为空！");
          return false;
        }
        if (!workLive.location || workLive.location === "") {
          this.$message.warning("工作经历地点不能为空！");
          return false;
        }
        if (!workLive.workDeptName || workLive.workDeptName === "") {
          this.$message.warning("工作经历任职部门不能为空！");
          return false;
        }
        if (!workLive.workPostName || workLive.workPostName === "") {
          this.$message.warning("工作经历任职职位不能为空！");
          return false;
        }
        if (!workLive.achievement || workLive.achievement === "") {
          this.$message.warning("工作经历业绩不能为空！");
          return false;
        }
      }
      for (let i = 0; i < data.projectLiveList.length; i++) {
        let projectLive = data.projectLiveList[i];
        if (!projectLive.startLiveTime || projectLive.startLiveTime === "") {
          this.$message.warning("科研项目经历开始时间不能为空！");
          return false;
        }
        if (!projectLive.endLiveTime || projectLive.endLiveTime === "") {
          this.$message.warning("科研项目经历结束时间不能为空！");
          return false;
        }
        if (projectLive.endLiveTime < projectLive.startLiveTime) {
          this.$message.warning("科研项目经历结束时间不能小于开始时间！");
          return false;
        }
        if (!projectLive.projectName || projectLive.projectName === "") {
          this.$message.warning("科研项目经历项目名称不能为空！");
          return false;
        }
        if (!projectLive.projectRole || projectLive.projectRole === "") {
          this.$message.warning("科研项目经历角色不能为空！");
          return false;
        }
        if (!projectLive.companyName || projectLive.companyName === "") {
          this.$message.warning("科研项目经历单位名称不能为空！");
          return false;
        }
        if (!projectLive.achievement || projectLive.achievement === "") {
          this.$message.warning("科研项目经历业绩不能为空！");
          return false;
        }
      }
      return true;
    },
    back() {
      this.$router.back();
    },
    nextActice() {
      if (!this.childDataCheck()) {
        return;
      }
      this.$emit("nextActice");
    },
    preActive() {
      if (!this.childDataCheck()) {
        return;
      }
      this.$emit("preActive");
    },
    addPracticeLive() {
      const newRow = {
        id: this.form.parcticeLiveList.length + 1,
        isEdit: true,
      };
      this.form.parcticeLiveList.push(newRow);
    },
    delPracticeLive(row) {
      const index = this.form.parcticeLiveList.findIndex(
        (e) => e.id === row.id
      );
      if (index !== -1) {
        this.form.parcticeLiveList.splice(index, 1);
      }
    },
    addWorkLive() {
      const newRow = {
        id: this.form.workLiveList.length + 1,
        isEdit: true,
      };
      this.form.workLiveList.push(newRow);
    },
    delWorkLive(row) {
      const index = this.form.workLiveList.findIndex((e) => e.id === row.id);
      if (index !== -1) {
        this.form.workLiveList.splice(index, 1);
      }
    },
    addProjectLive() {
      const newRow = {
        id: this.form.projectLiveList.length + 1,
        isEdit: true,
      };
      this.form.projectLiveList.push(newRow);
    },
    delProjectLive(row) {
      const index = this.form.projectLiveList.findIndex((e) => e.id === row.id);
      if (index !== -1) {
        this.form.projectLiveList.splice(index, 1);
      }
    },
    hasPracticeChange(e) {
      if (e === "是") {
        this.showPracticeAddButton = true;
      } else {
        this.showPracticeAddButton = false;
        this.form.parcticeLiveList = [];
      }
    },
    hasWorkLiveChange(e) {
      if (e === "是") {
        this.showWorkLiveAddButton = true;
      } else {
        this.showWorkLiveAddButton = false;
        this.form.workLiveList = [];
      }
    },
    hasProjectLiveChange(e) {
      if (e === "是") {
        this.showProjectLiveAddButton = true;
      } else {
        this.showProjectLiveAddButton = false;
        this.form.projectLiveList = [];
      }
    },
  },
};
</script>
<style scoped>
.tip-class {
  background: #f3f9ff;
  border: 1px solid #69b7ff;
  padding: 10px;
  border-radius: 2px;
  margin: 15px;
}
.icon-color {
  color: #1890ff;
}
.containerInfo {
  background-color: #f6f8f9;
  border-color: #f6f8f9;
}
</style>
